import React from "react";
import {
  Player,
  BigPlayButton,
  LoadingSpinner,
  ControlBar,
  ReplayControl,
} from "video-react";
import { useEffect, useState } from "react";
import {
  motion,
  useViewportScroll,
  useSpring,
  useTransform,
} from "framer-motion";

import cmdinitimage from "../../assets/img/cmdinit-min.png";
import packagejson from "../../assets/img/package-min.png";
import image1 from "../../assets/img/1-min.png";
import image2 from "../../assets/img/2-min.png";
import image3 from "../../assets/img/3-min.png";
import image4 from "../../assets/img/4-min.png";
import image5 from "../../assets/img/5-min.png";
import image6 from "../../assets/img/6-min.png";
import image7 from "../../assets/img/7-min.png";
import image8 from "../../assets/img/8-min.png";
import image9 from "../../assets/img/9-min.png";
import image10 from "../../assets/img/10-min.png";

let easing = [0.6, -0.05, 0.01, 0.99];

const fadeInUp = {
  initial: {
    y: 60,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

const Blog = () => {
  const [isComplete, setIsComplete] = useState(false);
  const { scrollYProgress } = useViewportScroll();
  const yRange = useTransform(scrollYProgress, [0, 0.9], [0, 1]);
  const pathLength = useSpring(yRange, { stiffness: 400, damping: 90 });

  useEffect(() => yRange.onChange((v) => setIsComplete(v >= 1)), [yRange]);

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit={{ opacity: 0 }}
      className="container"
    >
      <svg className="progress-icon" viewBox="0 0 60 60">
        <motion.path
          fill="none"
          strokeWidth="5"
          stroke="white"
          strokeDasharray="0 1"
          d="M 0, 20 a 20, 20 0 1,0 40,0 a 20, 20 0 1,0 -40,0"
          style={{
            pathLength,
            rotate: 90,
            translateX: 5,
            translateY: 5,
            scaleX: -1, // Reverse direction of line animation
          }}
        />
        <motion.path
          fill="none"
          strokeWidth="5"
          stroke="white"
          d="M14,26 L 22,33 L 35,16"
          initial={false}
          strokeDasharray="0 1"
          animate={{ pathLength: isComplete ? 1 : 0 }}
        />
      </svg>
      <motion.div variants={fadeInUp}>
        <h1 className="blogmaintitle">
          Part 1 Making GraphQl Api with Express.js, mongoDB.
        </h1>
      </motion.div>

      <motion.div
        animate={{ x: 0, opacity: 1 }}
        initial={{ x: 200, opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ delay: 0.2 }}
        className="blogcontent"
      >
        <p>
          Install
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="https://nodejs.org/en/download/"
            target="#"
          >
            Node.js.
          </a>
          Now open a folder you want to start your project. Open your terminal
          in that folder. Type this command
          <p className="command">npm init</p>
          You will see something like this and fill up those fields.
        </p>
        <img className="my_image" src={cmdinitimage} alt="cmdinitimage" />
        <p>
          Now type this command to install following packages
          <p className="command">
            npm install express cors express-graphql graphql mongoose
          </p>
          We need another package called nodemon which will restart the server
          whenever we make changes in files. We don't need this package in
          production build so we will install it as devloper dependency like
          this
          <p className="command">npm install nodemon --save-dev</p> After
          installation is completed open the package.json file in your code
          editor and edit the script section.
        </p>
        <img className="my_image_small" src={packagejson} alt="packagejson" />
        <p>
          The first line means if we type "npm run start" in the terminal node
          will run the app.js and if we type in "npm run server" in the nodemon
          will run the app.js file and whever make channges it will auto restart
          the server.
        </p>
        <p>
          Create a file named app.js in the folder and open it in your
          editor.Let's start coding now..
        </p>
        <img className="my_image_small" src={image1} alt="packagejson" />
        <p>
          The first line imports Express in our file, we have access to it
          through the variable Express. We use it to create an application and
          assign it to variable app.
        </p>
        <p className="blogfunction">app.get(route, callback)</p>
        <p>
          This function tells what to do when a get request at the given route
          is called. The callback function has 2 parameters, request(req) and
          response(res).
        </p>
        <p className="blogfunction"> res.send()</p>
        <p>
          This function takes an object as input and it sends this to the
          requesting client. Here we are sending the string "Hello World!". Next
          we set up variable PORT on which the server should accept incoming
          requests. process.env.PORT means use port 5000 unless there exists a
          preconfigured port. Open your cmd in the root folder and type
          <p className="command">npm run server</p> it will start the server in
          PORT 5000. Now Go to your broswer and open up "http://localhost:5000"
          and you will see "Hello World!".
        </p>
        <img className="my_image" src={image2} alt="packagejson" />
        <p>
          We have imported cors, mongoose which is accessible through variable
          cors and mongoose. You can name as you want.
        </p>
        <p className="blogfunction">cors</p>
        <p>
          The CORS standard works by adding new HTTP headers which allow servers
          to serve resources to permitted origin domains. Browsers support these
          headers and respect the restrictions they establish. app.use(cors())
          enable All CORS Requests.
        </p>
        <p className="blogfunction">mongoose</p>
        <p>
          Mongoose is an Object Data Modeling (ODM) library for MongoDB and
          Node.js. It manages relationships between data, provides schema
          validation, and is used to translate between objects in code and the
          representation of those objects in MongoDB.
        </p>
        <p>
          We will be using cloud database of mongoDb MongoDB Atlas. Open a
          account
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="https://www.mongodb.com/cloud/atlas"
            target="#"
          >
            here
          </a>
          and set up your database. You can see how to setup MongoDb Atlas in
          this
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href=" https://www.youtube.com/watch?v=KKyag6t98g8"
            target="#"
          >
            video
          </a>
          If you have complete all these process properly now you can see in
          your terminal MongoDB Connected.
        </p>
        <p>
          Create a folder named models and create a file named Product.js in
          that folder.
        </p>
        <img className="my_image" src={image3} alt="image3" />
        <p className="blogfunction">mongoose.Schema</p>
        <p>
          Everything in Mongoose starts with a Schema. Each schema maps to a
          MongoDB collection and defines the shape of the documents within that
          collection.
        </p>
        <p>
          Here we have defined our ImageSchema which is a object. It has a key
          named url.
        </p>
        <p className="blogfunction">url: String</p>
        <p>
          This means we can assign any String or text in url key. Example--
          {
            " { url: 'https://www.talkwalker.com/images/2020/blog-headers/image-analysis.png' },"
          }
        </p>
        <p>
          We have made a ProductSchema which has name, price, details, reviews
          and qty key and these keys take "String" as value. We have nested our
          ImageSchema in productimages key.
        </p>
        <p className="blogfunction">mongoose.model</p>
        <p>
          Whenever we call mongoose.model() on a schema, Mongoose creates a
          model in our database. It takes two parameter, our first parameter is
          products which is the collection name in the database where our data
          is saved and second parameter is which schema to save in our case it's
          ProductSchema.
        </p>
        <p className="blogfunction">module.exports</p>
        <p>
          module.exports is an object that the current module returns when it is
          "required" in another program or module so we can use it other files.
        </p>
        <p className="blogfunction">schema.js</p>
        <p>
          Now we will create our GraphQl Schema. Create a folder named schema
          and create a file named schema.js in that folder.
        </p>
        <img className="my_image" src={image4} alt="image3" />
        <p>
          We have imported graphql and ProductSchema from Product.js file. Now
          we have destructured some object from graphql object using javascript
          destructuring. I have made a gist
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="https://gist.github.com/kaneki666/1827a6f6ee7a2a635b50352e37667ff3"
            target="#"
          >
            file
          </a>
          to show how destructuring works. Now we will create a ProductImageType
          which is kind of similar to what we did in ImageSchema. Our
          ProductSchema was an object so we will have define it in graphql
          schema "new GraphQLObjectType()" which takes two parameter name,
          fields. We can assign any name we want and fields returns a function.
          In that function we will define our schema key and type. Example--
          {"name: { type: GraphQLString },"}. In productimages key we have
          nested the ProductImageType. We have to define what kind of data we
          are passing. As we will be passing array we will have to tell graphql
          it's a GraphQLList.
        </p>
        <p className="blogfunction">RootQuery</p>
        <p>
          A GraphQL query is used to read or fetch. It's similar to get request.
          Before we start to query we need some data in our database. I have
          made some demo data which matches our schema. Upload this
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="https://gist.github.com/kaneki666/175576db7ba6f64fd52681414c7a0478"
            target="#"
          >
            file
          </a>
          to your db. Now we will write our RootQuery.
        </p>
        <img className="my_image" src={image5} alt="packagejson" />
        <p>
          We have initialized a new GraphQLObjectType which contains an object
          type within GraphQL that contains fields. We have two fields
          <p className="command">
            1-products(which will query all products from db)
          </p>
          <p className="command">
            2-product(which will find specific product from db)
          </p>
          In our products field it has type which is the what type of data we
          query. We will query ProductType data. As there is more than one
          object we want to query, we say new GraphQLList which will give us a
          list of ProductType data. We aren't passing any argument cause we dont
          want any specific product as we want all so kept it empty. In our
          product query we are passing args "_id" so we can findOne product that
          has args "_id" Finally we have <p className="command">resolve</p>
          resolve function has two argument:
          <p className="command">resolve(parent, args)</p> We use parent
          argument when we build relationship between data, args is argument in
          args field.Inside resolve function we write our code to get data from
          our db. We simplly
          <p className="command">return ProductSchema.find({});</p>
          which returns our products collection data from db.
        </p>
        <p className="command">
          return ProductSchema.find({"{ _id: args._id }"});
        </p>
        <p>
          It returns the specific object filtering by "_id". Finally we export
          our query: RootQuery as GraphQLSchema so we can use it other files.
          Let's update our app.js file.
        </p>
        <img className="my_image" src={image6} alt="packagejson" />
        <p>
          We have imported graphql-express and schema file. We use
          graphql-express to create a GraphQL HTTP server. Then we have added
          <p className="command">app.use("/graphql",graphqlHTTP({}) )</p>
          graphqlHTTP function takes schema option and graphiql. If graphiql =
          true, presents GraphiQL when the GraphQL endpoint is loaded in a
          browser. When we go to /graphql endpoint it will open a tool where we
          can query our data.Some query example given below. Now open your
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="http://localhost:5000/graphql"
            target="#"
          >
            browser
          </a>
          to make some query.
        </p>
        <Player src="https://srv-file5.gofile.io/download/qHeReK/bandicam%202020-06-19%2014-03-14-194_Segment_0_x264.mp4">
          <BigPlayButton position="center" />
          <LoadingSpinner />
          <ControlBar autoHide={false}>
            <ReplayControl seconds={5} order={2.1} />
            <ReplayControl seconds={10} order={2.2} />
            <ReplayControl seconds={30} order={2.3} />
          </ControlBar>
        </Player>
        <p>
          You can see in the query we can customize our query, we can specify
          what data we want in our query. That's the number one advantage over
          REST API.
        </p>

        <img className="my_image" src={image7} alt="packagejson" />
        <p className="blogfunction">ProductImageTypeInput</p>
        <p>
          As our productimages is an array we have specify it as
          GraphQLInputObjectType. GraphQLInputObjectType is an input object type
          in GraphQl that represents structured inputs. It takes a fields, the
          fields returns a function which contains our url which is a
          GraphQLString type.
        </p>
        <p className="blogfunction">addProduct mutation</p>
        <p>
          Mutation queries modify data in the data store and returns a value. It
          can be used to insert, update, or delete data. We can say Mutaions are
          post request .Now lets create our mutation in our schema file. Same as
          RootQuery it has fields which contains our mutation. Our first
          mutation is addProduct which type is ProductType, it takes args of
          ProductType. In in the resolve function we create a variable named
          product which takes the args. Finally we call
        </p>
        <p className="command">product.save()</p>
        <p>mongoose saves the data in your db products collection.</p>
        <p className="blogfunction">updateProduct mutation</p>

        <p>
          Now we will create a update mutation. It will have same type and args.
          In the resolve function we will find the product by "_id" we want to
          update. When we call
        </p>
        <img className="my_image" src={image9} alt="packagejson" />
        <p>
          code we find the specific product we want. Then (err, data) executes
          if we find err we return err if we find data we assign our args we
          want to update. Then we check if args.name, args.price...variable are
          empty or not . If those are empty we assign those variable
          data.name..... Example:
        </p>
        <p className="command">
          if (name == null || name == "") {" {name= data.name;}"}
        </p>
        <p>
          if name is null or empty string we assign our original name of product
          which can be accessed as data.name as name
        </p>
        <p className="blogfunction">ProductSchema.findOneAndUpdate({})</p>
        <p>
          now we update our db, findOneAndUpdate takes 3 parameter(query,
          {"{$set:{new_data}"}, {"{new: true}"}). Finally we exec it and if we
          find err we output it, if success in operation we output it as res
          variable.
        </p>
        <img className="my_image" src={image8} alt="packagejson" />
        <p className="blogfunction">deleteProduct mutation</p>
        <img className="my_image" src={image10} alt="packagejson" />
        <p> We call the</p>
        <p className="blogfunction">
          ProductSchema.findOneAndDelete({"{ _id: args._id }"});
        </p>
        <p>
          It finds the product by id and deletes it. Before we test we will
          empty the db collection of products. Now let's test our mutation.
        </p>
        <Player src="https://srv-file18.gofile.io/download/BhOcUd/bandicam%202020-06-19%2021-18-20-487_Segment_0_x264.mp4">
          <BigPlayButton position="center" />
          <LoadingSpinner />
          <ControlBar autoHide={false}>
            <ReplayControl seconds={5} order={2.1} />
            <ReplayControl seconds={10} order={2.2} />
            <ReplayControl seconds={30} order={2.3} />
          </ControlBar>
        </Player>
        <h3 style={{ textAlign: "center", color: "#ff6e5c", marginTop: 20 }}>
          Full code is
          <a
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            href="https://github.com/kaneki666/GraphQl_API"
            target="#"
          >
            here
          </a>
        </h3>
      </motion.div>
    </motion.div>
  );
};

export default Blog;
